import React, { useState } from "react";
import { ShieldAlert } from "lucide-react";
import { Logo } from "../shared";

export const disclaimerKey = (shareId, who) => `xyz_room_disclaimer_${shareId}_${(who || "").toLowerCase()}`;

export const DISCLAIMER_TEXT = "This preliminary, confidential package offers a limited overview of an investment opportunity through XYZ Venture, LLC, relating to the equity instrument described in the Private Placement Memorandum, Company Agreement, and Subscription Agreement; it is intended solely for the original recipients' use in evaluating their interest and does not constitute an offer or solicitation. While compiled from sources believed reliable, XYZ Ventures and its representatives make no warranty as to its accuracy or completeness, and all financial information and projections are for reference only, based on assumptions beyond our control — prospective investors should conduct independent due diligence and consult their own legal, tax, and financial advisors before investing. Available exclusively to accredited or sophisticated investors.";

export function DisclaimerModal({ investor, onAccept }) {
  const [agree, setAgree] = useState(false);
  return (
    <div className="modal-overlay disc-overlay" data-testid="disclaimer-modal">
      <div className="modal-card disc-card" onClick={(e) => e.stopPropagation()}>
        <div className="disc-head">
          <Logo height={36} />
          <div>
            <div className="ig-brand">XYZ Ventures · Investor Deal Room</div>
            <div className="modal-title" style={{ display: "flex", alignItems: "center", gap: 8 }}><ShieldAlert size={16} /> Disclaimer</div>
          </div>
        </div>
        <p className="disc-text" data-testid="disclaimer-text">{DISCLAIMER_TEXT}</p>
        <label className="disc-agree" data-testid="disclaimer-agree-row">
          <input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} data-testid="disclaimer-checkbox" />
          <span>I, <b>{investor || "the recipient"}</b>, have read and understand this disclaimer and agree to keep this material confidential.</span>
        </label>
        <button className="btn btn-primary" style={{ width: "100%", marginTop: 14 }} disabled={!agree} onClick={onAccept} data-testid="disclaimer-accept">I agree — enter the deal room</button>
      </div>
    </div>
  );
}
